import FilterStars from './FilterStars';

export default FilterStars;
